// src/components/winback/UrgencyBadge.jsx
import React from 'react';

const UrgencyBadge = ({ urgency }) => {
    const config = {
        high: {
            bg: 'bg-red-100',
            text: 'text-red-800',
            label: 'Alta',
            icon: '🔴'
        },
        medium: {
            bg: 'bg-yellow-100',
            text: 'text-yellow-800',
            label: 'Media',
            icon: '🟡'
        },
        low: {
            bg: 'bg-green-100',
            text: 'text-green-800',
            label: 'Baja',
            icon: '🟢'
        }
    };

    const style = config[urgency] || config.low;

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text}`}>
            <span className="mr-1">{style.icon}</span>
            {style.label}
        </span>
    );
};

export default UrgencyBadge;

